import $ from 'jQuery';
var stringSimilarity = require("string-similarity");

class newSearch {
  // 1. describe and create/initiate our object
    // constructor function is just for our object properties not methods
  constructor() {
    // create a function that has a default state of all laureates displayed, but if a user uses the searchbar then it will only display the laureates being searched

    // create and store a variable that connects to the HTML input
    const inputValue = document.querySelector('#search-term');
    const defaultLaureateGallery = document.querySelector('.gallery__laureates--default');

    function inputSearchQuery() {
      if (inputValue.value.length) {
        // IF the input has been typed into only display the search results
        defaultLaureateGallery.classList.add('hideGallery');

        // IF there was a change in the input erase the old searches
      } else {
        // ELSE the default empty input renders all of the laureates
        defaultLaureateGallery.classList.remove('hideGallery');
      }
    }

    inputSearchQuery();
    inputValue.addEventListener('input', inputSearchQuery);

    this.openButton = $('.js-search-trigger');
    this.closeButton = $('.search-overlay__close');
    this.searchOverlay = $('.search-overlay');
    this.searchField = $('#search-term');
    this.resultsDiv = $('#search-overlay__results');

    // we have to call the events function in order for it be "activated" otherwise it it is never called it cannot do work
    this.events();

    this.isSpinnerVisible = false;
    this.previousValue;
    this.typingTimer;
    }
    
    
// METHODS
  // 2. events
  events() {
    // this.openButton.on("click", this.openOverlay.bind(this));
    // this.closeButton.on("click", this.closeOverlay.bind(this));
    this.searchField.on('keyup', this.typingLogic.bind(this));
  }

    // 3. methods (function, action...)
    typingLogic() {
        // if the searchField's value is not the previous value
        if (this.searchField.val() != this.previousValue) {
            
            // $.getJSON(NSBHFData.root_url + '/wp-json/wp/v2/laureates?search=' + this.searchField.val(),
            // (laureates) => {
            //     // need to have a search prompt feature that uses keywords to suggest things to users
            //     // storing the queryList ul into a variable  
            //     let searchWrapper  = document.querySelector('.search-input')
            //     let inputBox = document.getElementById('search-term');
            //     let suggBox = document.getElementById('autocom-box');
            //     let searchResultsGallery = document.querySelector('.leaureate-card-gallery__search')

            //     // looping through each of the JSON objects and extracting the keywords as a string
            //     let keywords;
            //     for (let i = 0; i < laureates.length; i++) {
            //         console.log(laureates[i].keywords, "checking the keywords")
            //         keywords = laureates[i].keywords;
            //         console.log(keywords);
            //     }

            //     if (keywords != null) {
            //         // taking the string of keywords and splitting them by the comma
            //         let keywordArr = keywords.split(",");
                    
            //         console.log(keywordArr);
        
            //         inputBox.onkeyup = (e) => {
            //             let userInput = e.target.value; // user entered data
            //             let emptyArray = [];
            //             if (userInput) {
            //                 emptyArray = keywordArr.filter((data) => {
            //                     // filtering array value and user char to lowercase and 
            //                     // returns only the words/sentances that start with the search term
            //                     return data.toLocaleLowerCase().startsWith(userInput.toLocaleLowerCase());
            //                 })
            //                 console.log(emptyArray, "One");
            //                 emptyArray = keywordArr.map((data) => {
            //                     console.log(data, "displaying data mapped from empty array")
            //                     return data = `<li>${data}</li>`;
            //                 });
            //                 console.log(emptyArray);
            //                 // show auto complete box here with classlist adding an active class
            //                 suggBox.classList.add("activeSearch");
            //             } else {
            //                 // hide autocomplete box here with a hide class
            //                 suggBox.classList.remove("activeSearch");
            //             }
            //             showSuggestions(emptyArray);
            //         }

            //         // this function will show the words into the autocomplete box
            //         function showSuggestions(list) {
            //             let listData;
            //             if (!list.length) {
            //                 let userValue;
            //                 userValue = inputBox.value;
            //                 // console.log(userValue);
            //                 listData = `<li>${userValue}</li>`;

            //             } else {
            //                 listData = list.join('');
            //             }
            //             suggBox.innerHTML = listData;
            //         }
            //     }
            // })

            // reset the timer
            clearTimeout(this.typingTimer);

            if (this.searchField.val()) {
                if (!this.isSpinnerVisible) {
                    this.resultsDiv.html('<div class="spinner-loader"></div>');
                    this.isSpinnerVisible = true;
                }
                this.typingTimer = setTimeout(this.getResults.bind(this), 750);
            } else {
                this.resultsDiv.html('');
                this.isSpinnerVisible = false;
            }
        }
        this.previousValue = this.searchField.val();
    }


    
    // this.searchField.val() is equal to whatever you search in the input field
    getResults() {
        // get JSON data from the url nslaureates.ca/ the wordpress API plus the search field value...
        $.getJSON(NSBHFData.root_url + '/wp-json/wp/v2/laureates?search=' + this.searchField.val(),
        (laureates) => {
            let masterLaureateArray = [];

            // looping through each of the JSON objects
            for (let i = 0; i < laureates.length; i++){
                // storing search value into a variable
                let searchQuery = this.searchField.val();

                //storing extracted JSON data into variables
                let title = laureates[i].title.rendered;
                let bio = laureates[i].bio;
                let image = laureates[i].laureate_portrait_image;
                let keywords = laureates[i].keywords;
                let link = laureates[i].link;
                let inductionDate = laureates[i].inductionDate;

                // scoring the title, keywords and bio to determine a priority score
                let titleScore = stringSimilarity.compareTwoStrings(title, searchQuery);
                let keywordsScore = stringSimilarity.compareTwoStrings(keywords, searchQuery);
                let bioScore = stringSimilarity.compareTwoStrings(bio, searchQuery);
                let priorityScore = titleScore + keywordsScore + bioScore;

                // creating a laureate object with the new priorty score and relevant data
                let singleLaureateObj = {
                    score: priorityScore,
                    name: title,
                    description: bio,
                    keywords: keywords,
                    image: image,
                    link: link,
                    inductionDate: inductionDate
                };

                // pushing the single laureate objects into a master array
                masterLaureateArray.push(singleLaureateObj);
            }
            
            // using this sorting function to rank the single laureates in the master array from least (index = 0) to greatest 
            var sorted_laureates = masterLaureateArray.sort(function(a, b) {
                return a.score - b.score;
            });

            // console.log(sorted_laureates);

            // reversing the sorted array so that the best score comes first
            let reverse_sorted_laureates = sorted_laureates.reverse();
            
            // if there are no search results found then say "no search results found"
            this.resultsDiv.html(`${reverse_sorted_laureates.length ? '<div class="leaureate-card-gallery__search">' : '<p>No search results found</p>'}
            
                ${reverse_sorted_laureates.map((item) =>
                // SINGLE LAUREATE CARD IN SEARCH
                `<div class="laureate-card-gallery">
                    <a href="${item.link}">
                        <div class="laureate-card-gallery__image" style="background-image:url('${item.image}')">
                    </a>
                        </div>
                
                    <div class="laureate-card-gallery__info">
                        <div class="laureate-card-gallery__info--text">
                            <h4>Inducted &#8212; ${item.inductionDate}</h4>
                            <h2>${item.name}</h2>
                            <p>${item.description}</p>
                        </div>

                        <a href="${item.link}" class="btn btn__underline">
                            <span class="btn__underline-container">Learn more</span>
                        </a>
                    </div>
                </div>`
                // SINGLE LAUREATE CARD IN SEARCH
                    
                    ).join('')}
                ${laureates.length ? '</ul>' :
            ''}`);
                this.isSpinnerVisible = false;
        });
    }
    
}

export default newSearch;

